import Reflux from "reflux";
export const ProvidersActions = {
  get: Reflux.createAction()
};
